export const difficultyLevel = {
  1: "Very easy",
  2: "Easy",
  3: "Medium",
  4: "Hard"
};

export const nutritionalCategoryOptions = [
  {
    value: 1,
    label: "Weight Loss"
  },
  {
    value: 2,
    label: "Weight Gain"
  },
  {
    value: 3,
    label: "High Protein"
  },
  {
    value: 4,
    label: "Low Carb"
  },
  {
    value: 5,
    label: "Vegan"
  },
  {
    value: 6,
    label: "Vegetarian"
  },
  {
    value: 7,
    label: "Breakfast"
  },
  {
    value: 8,
    label: "Dinner"
  },
  {
    value: 9,
    label: "Snacks"
  },
  {
    value: 10,
    label: "Sides"
  },
  {
    value: 11,
    label: "Drinks & Smoothies"
  },
  {
    value: 12,
    label: "Lunch"
  },
  {
    value: 13,
    label: "Dairy Free"
  },
  {
    value: 14,
    label: "Gluten Free"
  },
  {
    value: 15,
    label: "Dash"
  },
  {
    value: 16,
    label: "Mediterranean"
  }
];
